export const getPlanByStatus =
  planStatus =>
  ({ status }) =>
    status === planStatus;
